import { assign } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const getProductWithMeasurementsFailure = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    if (
      event.type !==
      'error.platform.productBuilder.measurements.loading:invocation[0]'
    )
      return context;

    // Check if this is a curtain product
    const isCurtain = 
      context.products[0]?.type === 'Curtain' ||
      (typeof window !== 'undefined' && window.location.pathname.includes('curtain'));

    // For CURTAINS ONLY: On API failure, preserve the previous productWithMeasurements if it's valid
    // Otherwise set to null to show $0 price
    // For other products: keep the old behavior (set error message)
    if (isCurtain) {
      const previousValue = context.productWithMeasurements;
      const isValidPreviousValue = 
        previousValue !== null && 
        typeof previousValue !== 'string' && 
        previousValue.data && 
        Array.isArray(previousValue.data);

      console.error('Calculate API failed for curtain:', event.data.message);
      
      return { 
        ...context, 
        productWithMeasurements: isValidPreviousValue ? previousValue : null 
      };
    } else {
      // For non-curtain products, keep the existing behavior
      return { ...context, productWithMeasurements: event.data.message };
    }
  },
);
